import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ApiService } from 'app/api.service';
import { LoaderService } from 'app/loader.service';

declare var alertify: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit {
  private Parse: any = require('parse');

  model: any = { };
  currentUser: any;

  constructor(
    private router: Router,
    public apiService: ApiService,
    private loaderService: LoaderService
  ) {
    if (this.Parse.User.current()) {
      this.currentUser = this.Parse.User.current();
    }
  }

  ngOnInit() {
    this.router.navigate(['/']);
    // this.loaderService.setLoaded();
  }

  logIn() {
    this.router.navigate(['/']);
    // this.apiService.Parse.User.logIn(
    //   this.model.username,
    //   this.model.password
    // ).then(
    //   success => {
    //     if (this.apiService.Parse.User.current()) {
    //       this.router.navigate(['/home']);
    //     }
    //   }
    // ).catch(
    //   error => alertify.error(error.message)
    // );
  }

  logInWithFacebook() {
    // if (!this.apiService.isFacebookInitialized()) {
    //   return;
    // }

    // this.apiService.Parse.FacebookUtils.logIn(null, {}).then(
    //   success => {
    //     this.router.navigate(['/home']);
    //   }
    // ).catch(
    //   error => alertify.error(error.message)
    // );
  }

}



// WEBPACK FOOTER //
// /tmp/build_769bc651/src/app/login/login.component.ts